import { render, staticRenderFns } from "./steelBox.vue?vue&type=template&id=85f17e86&scoped=true"
import script from "./steelBox.vue?vue&type=script&lang=js"
export * from "./steelBox.vue?vue&type=script&lang=js"
import style0 from "./steelBox.vue?vue&type=style&index=0&id=85f17e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f17e86",
  null
  
)

export default component.exports